import { EDownloadReportType } from 'core/model/enums';
import { IDownloadReportItem } from 'core/model/interfaces/downloads-uploads';
import type { TSliceReducer } from 'core/store/store';
import type { IDownloadsState } from './downloads.types';

const updateDownloadFilterReportType: TSliceReducer<IDownloadsState, EDownloadReportType> = (state, action) => {
  state.filters.reportType = action.payload;
};

const updateDownloadReportListPage: TSliceReducer<IDownloadsState, number> = (state, action) => {
  state.list.pagination.currentPage = action.payload;
};

const setDownloadReportListStatus: TSliceReducer<IDownloadsState, Pick<IDownloadReportItem, 'id' | 'status'>> = (
  state,
  action,
) => {
  const { id, status } = action.payload;

  const item = state.list.downloads.find(item => item.id === id);

  if (item) {
    item.status = status;
  }
};

export const reducers = {
  updateDownloadFilterReportType,
  updateDownloadReportListPage,
  setDownloadReportListStatus,
};
